import { SET_IS_OPEN } from '../../../types/conversations/plugins'

const isOpen = (userId, isOpen) => ({
  userId,
  isOpen,
  type: SET_IS_OPEN,
})

const isOpenAct = (user, open) => (dispatch) => {
  dispatch(isOpen(user, open))
}

export default { isOpenAct }
